module.exports = __webpack_public_path__ + "media/images/icons/translate-ce118094bb05674cd28edaed00fa0f49.svg";